module.exports = __webpack_public_path__ + "static/media/p2.748e1801.png";